import React from 'react';
import { Modal, StackView, Spinner } from '@telus-uds/components-web';
import { useTranslation } from 'react-i18next';

const ProcessingOverlay = ({ isProcessing, type }) => {
  const { t } = useTranslation();

  if (!isProcessing) return null;

  return (
    <Modal isOpen={true} closeButton={null}>
      <StackView
        tokens={{
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
        }}
      >
        <Spinner show label={t(`processing.${type}`)} />
      </StackView>
    </Modal>
  );
};

export default ProcessingOverlay;
